'use strict';

angular.module('dekky.forms.themes.customPartner')
.run(function($templateCache) {
	$templateCache.put('/dekky.forms/themes/customPartner/fields/imageUpload.html',
		'<span ng-init="model = uploader.queue">' +
			'<ul class="form-list">' +
				'<li class="form-list__item form-list__item_icon" ng-repeat="item in uploader.queue">' +
					'<span class="form-list__link" ng-if="item.isUploaded && item.isSuccess">{{ item.file.name }}</span>' +
					'<span ng-if="item.isUploaded && item.isError" class="relative">' +
						'<span class="form-list__link">{{ item.file.name }}</span>'+
						'<span class="form__error_inline">Ошибка</span>' +
					'</span>' +
					'<span class="form-list__item-close" ng-click="item.remove()"></span>' +
					'<span class="" ng-if="item.isUploading"><i class="fa fa-spinner fa-pulse"></i></span>' +
				'</li>' +
			'</ul>' +
			'<input class="btn-file-upload__input" id="{{ field.name + \'_\' + fieldIndex }}" type="file" nv-file-select uploader="uploader" filters="images">' +
		'</span>'
	);
});